import { Component, Input, OnInit } from '@angular/core';
import { Constants, SessionStorageService } from '../_services';

@Component({
  selector: 'app-header-public',
  templateUrl: 'header-public.component.html'
})
export class HeaderPublicComponent implements OnInit {
  @Input()
  SiteName: string;
  @Input()
  LogoImage: string;
  @Input()
  LogoImageAlt: string;
  @Input()
  FeaturesLabel: string;
  @Input()
  EnglishLanguageLabel: string;
  @Input()
  FrenchLanguageLabel: string;
  @Input()
  SkipToMainContentText: string;

  altLanguageLabel: string;

  constructor(private sessionState: SessionStorageService) {}

  ngOnInit(): void {
    const altLanguageCode = this.sessionState.getAltLanguageCode();
    if (altLanguageCode === Constants.LanguageCodeEnglish) {
      this.altLanguageLabel = this.EnglishLanguageLabel;
    } else {
      this.altLanguageLabel = this.FrenchLanguageLabel;
    }
  }

  toggleLanguage(event: Event): void {
    event.preventDefault();

    this.sessionState.toggleCurrentLanguageCode();
  }

  skipToMainContent(event: Event): void {
    event.preventDefault();

    const elMain = document.getElementById('public-wrapper');
    if (elMain != null) {
      elMain.scrollIntoView({ behavior: 'instant', block: 'start' });
      elMain.focus();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/global/header-public.component.ts